import React, { useEffect, useState } from "react";

import AffilaiteTable from "../components/AffiliateTable.tsx";
import {
  Button,
  Card,
  Col,
  Container,
  DropdownButton,
  Pagination,
  Row,
  Table,
} from "react-bootstrap";
import {
  copyToClipboard,
  exportAffiliatesToExcel,
  exportSalesToExcel,
  formatBalance,
  shortenAddress,
} from "../utils/utils.ts";
import {
  chainId,
  etherscanAPIKEY,
  isTestEnv,
  network,
  presaleAbi,
  presaleAddress,
  token,
  tokenAddress,
} from "../utils/contants.js";
import { useTranslation } from "react-i18next";
import { ethers } from "ethers";
import { toast } from "react-toastify";
import { Affiliate } from "../types/Affiliate.ts";
import { Sale } from "../types/Sale.ts";
import { useWeb3ModalAccount } from "@web3modal/ethers/react";
import Decimal from "decimal.js";
import { useMediaQuery } from "react-responsive";
import { Dropdown } from "react-bootstrap";
import { useMemo } from "react";

const Sales: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { address } = useWeb3ModalAccount();
  const [presaleContract, setPresaleContract] =
    useState<ethers.Contract | null>(null);
  const [affiliates, setAffiliates] = useState<Affiliate[]>([]);
  const [sales, setSales] = useState<Sale[]>([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 20;

  // Calculate paginated sales for current page
  const paginatedSales = useMemo(() => {
    return sales.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  }, [currentPage, itemsPerPage, sales]);

  // Calculate total pages
  const totalPages = Math.ceil(sales.length / itemsPerPage);

  const [loading, setLoading] = useState(true);
  const [contractOwner, setContractOwner] = useState("");
  const pageSize = 100; //max 100 responses for affiliate

  const fetchNonReferralSales = async (affiliates: Affiliate[]) => {
    try {
      let res = await (
        await fetch(
          `https://api-testnet.bscscan.com/api?chainid=${chainId}&module=account&action=txlist&address=${presaleAddress}&startblock=0&endblock=99999999&page=1&offset=2000&sort=desc&apikey=${etherscanAPIKEY}`
        )
      ).json();
      let contractTXs = res.result.filter(
        (item) =>
          item.methodId === "0x898b1ff8" || item.methodId === "0x995a4001"
      );

      res = await (
        await fetch(
          `https://api-testnet.bscscan.com/api?chainid=${chainId}&module=account&action=tokentx&contractaddress=${tokenAddress}&address=${presaleAddress}&startblock=0&endblock=99999999&page=1&offset=2000&sort=desc&apikey=${etherscanAPIKEY}`
        )
      ).json();

      let tokenTransfers = res.result;
      console.log(res)
      //maps hash -> token amount transferred t
      let amountMap = new Map<string, number>();
      tokenTransfers.forEach((item) => {
        amountMap.set(item.hash, parseInt(item.value));
      });

      const ipresale = new ethers.Interface(presaleAbi);

      let noReferralSales: Sale[] = [];
      console.log(amountMap,contractTXs);
      for (let i = 0; i < contractTXs.length; i++) {
        //get decoded input ,
        if (contractTXs[i].methodId === "0x995a4001") {
          const decoded = ipresale.decodeFunctionData(
            "buyWithUSDT",
            contractTXs[i].input
          );
          if (affiliates.find((item) => item.code === decoded.code)) continue;
          //buy with usdt
          noReferralSales.push(
            new Sale({
              code: "",
              investment: decoded.amount,
              isUsdtPurchase: true,
              purchaseTime: contractTXs[i].timeStamp,
              user: contractTXs[i].from,
              tokensTransferred: new Decimal(
                amountMap.get(contractTXs[i].hash)!
              ),
              profit: new Decimal(0),
            })
          );
        } else {
          //buy with native
          const decoded = ipresale.decodeFunctionData(
            "buyWithNative",
            contractTXs[i].input
          );
          if (affiliates.find((item) => item.code === decoded.code)) continue;
          //buy with usdt
          noReferralSales.push(
            new Sale({
              code: "",
              investment: contractTXs[i].value,
              isUsdtPurchase: false,
              purchaseTime: parseInt(contractTXs[i].timeStamp),
              user: contractTXs[i].from,
              tokensTransferred: new Decimal(
                amountMap.get(contractTXs[i].hash)!
              ),
              profit: new Decimal(0),
            })
          );
        }
      }
      return noReferralSales;
    } catch (error) {
      console.log(error);
    }
  };
  const parseAffiliates = (data: any[]) => {
    let affs: Affiliate[] = [];
    for (let i = 0; i < data.length; i++) {
      let affiliate = Affiliate.fromEthersResponse(data[i]);
      // Stop if we hit a zero address
      if (affiliate.user === ethers.ZeroAddress) break;
      affs.push(affiliate);
    }
    return affs;
  };

  // Fetch affiliate details from the contract
  // Fetch referral sales history with pagination
  const fetchSalesHistory = async (code: string) => {
    if (!presaleContract) return;
    try {
      const salesData = await presaleContract.getAffiliateSales(
        code,
        pageSize,
        0
      );
      //implment pagination here
      console.log("sales", salesData);
      let parsedSales: Sale[] = [];
      for (let i = 0; i < salesData.length; i++) {
        let sale = Sale.fromEthersResponse(salesData[i]);
        sale.code = code;
        parsedSales.push(sale);
      }

      return parsedSales;
    } catch (error: any) {
      // Swal.fire(t("error.error"), t("error.loading_history"), "error");
      console.error(error);
      return [];
    }
  };

  const syncAffiliates = async () => {
    try {
      if (!presaleContract) return;
      setLoading(true);
      const offset = (currentPage - 1) * pageSize;
      const result = await presaleContract.getAffiliates(pageSize, offset);
      const affs = parseAffiliates(result);
      setAffiliates(affs);
      let sales: Sale[] = [];
      for (let i = 0; i < affs.length; i++) {
        let affSales = await fetchSalesHistory(affs[i].code);
        if (affSales) {
          sales = sales.concat(affSales);
        }
      }
      let noReferralSales = await fetchNonReferralSales(affs);
      if (noReferralSales) {
        sales = sales
          .concat(noReferralSales)
          .sort((a, b) => b.purchaseTime.getTime() - a.purchaseTime.getTime());
      }
      setSales(sales);
    } catch (error) {
      console.log(error);
      toast.error(error.toString());
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    syncAffiliates();
  }, [presaleContract]);

  const performCopy = async (text: string) => {
    const res = await copyToClipboard(text);
    if (res) {
      toast.success("Copied to clipboard");
    } else {
      toast.error("Failed to copy");
    }
  };

  const initContract = async () => {
    const provider = new ethers.JsonRpcProvider(network.rpcUrl);
    const contract = new ethers.Contract(presaleAddress, presaleAbi, provider);
    const ownerAddress = await contract.owner();
    setContractOwner(ownerAddress);
    setPresaleContract(contract);
  };
  // Initialize the contract connection
  useEffect(() => {
    initContract();
  }, []);

  if (
    !isTestEnv &&
    (!address || address.toLowerCase() !== contractOwner.toLowerCase())
  ) {
    return (
      <Container className="text-center mt-5">
        <h3>{t("info.only_owner")}</h3>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Card className="mb-4">
        <Card.Body>
          <Row className="g-4 mb-3">
            <Col
              md={7}
              style={{
                alignItems: "center",
              }}
            >
              <h5 style={{ marginBottom: "0px" }}>
                {t("sales.sales_history")}
              </h5>
            </Col>
            <div
              style={{
                flex: "1",
              }}
            ></div>
            <Col md={3}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                {t("sales.show")}
                <DropdownButton
                  id="dropdown-pages"
                  title={itemsPerPage}
                  onSelect={(e) => {
                    setItemsPerPage(Number(e));
                  }}
                >
                  {[10, 20, 30, 40, 50].map((num) => (
                    <Dropdown.Item eventKey={num} key={num}>
                      {num}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
                {t("sales.per_page")}
              </div>
            </Col>
            <Col md={1}>
              <div className="me-3">
                <Button
                  onClick={() => {
                    exportSalesToExcel(sales);
                  }}
                  variant="primary"
                >
                  {t("affiliates.export")}
                </Button>
              </div>
            </Col>
          </Row>
          {sales.length === 0 ? (
            <div className="text-center py-4">
              <h5>
                {loading ? t("sales.fetching_data") : t("sales.no_sales_yet")}
              </h5>
            </div>
          ) : (
            <>
              <div
                style={{
                  maxWidth: isMobile ? "100%" : "calc(100vw - 358px)",
                }}
              >
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="text-center"
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>{t("user.user_address")}</th>
                      <th>{t("user.invest_eth")}</th>
                      <th>{t("user.invest_usdt")}</th>
                      <th>{t("user.is_usdt_purchase")}</th>
                      <th>{t("user.tokens_received")}</th>
                      <th>{t("user.profit_eth")}</th>
                      <th>{t("user.profit_usdt")}</th>
                      {/* <th>{t("user.commission")}</th> */}
                      {/* <th>{t("user.currency")}</th> */}
                      <th>{t("user.referrer")}</th>
                      <th>{t("user.date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedSales.map((sale, index) => (
                      <tr key={index} style={{ whiteSpace: "nowrap" }}>
                        <td>
                          {sales.length -
                            ((currentPage - 1) * itemsPerPage + index)}
                        </td>
                        <td>
                          <div className="d-flex justify-content-between align-items-center">
                            <img
                              src="/copy-file-icon.svg"
                              height={24}
                              width={24}
                              className="ms-3"
                              style={{ cursor: "pointer" }}
                              alt="copy"
                              onClick={() => performCopy(sale.user)}
                            />
                            {sale.user}
                          </div>
                        </td>
                        {/* <td>{shortenAddress(sale.user, 8)}</td> */}

                        <td>
                          {sale.isUsdtPurchase
                            ? `0`
                            : `${formatBalance(Number(sale.investment), 18)}`}
                        </td>
                        <td>
                          {sale.isUsdtPurchase
                            ? `${formatBalance(Number(sale.investment), 6)}`
                            : `0`}
                        </td>
                        <td>{sale.isUsdtPurchase ? "Yes" : "No"}</td>
                        <td>
                          {formatBalance(
                            Number(sale.tokensTransferred),
                            token.decimals
                          )}{" "}
                        </td>
                        <td>
                          {sale.isUsdtPurchase
                            ? `0`
                            : `${formatBalance(Number(sale.profit), 18)}`}
                        </td>
                        <td>
                          {sale.isUsdtPurchase
                            ? `${formatBalance(Number(sale.profit), 6)}`
                            : `0`}
                        </td>

                        <td>{sale.code ?? "--"}</td>
                        <td>{sale.purchaseTime.toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Pagination className="justify-content-center">
                  <Pagination.First
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() =>
                      setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev))
                    }
                    disabled={currentPage === 1}
                  />

                  {currentPage > 2 && (
                    <>
                      <Pagination.Item onClick={() => setCurrentPage(1)}>
                        1
                      </Pagination.Item>
                      {currentPage > 3 && <Pagination.Ellipsis disabled />}
                    </>
                  )}

                  {currentPage > 1 && (
                    <Pagination.Item
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      {currentPage - 1}
                    </Pagination.Item>
                  )}

                  <Pagination.Item active>{currentPage}</Pagination.Item>

                  {currentPage < totalPages && (
                    <Pagination.Item
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      {currentPage + 1}
                    </Pagination.Item>
                  )}

                  {currentPage < totalPages - 1 && (
                    <>
                      {currentPage < totalPages - 2 && (
                        <Pagination.Ellipsis disabled />
                      )}
                      <Pagination.Item
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    </>
                  )}

                  <Pagination.Next
                    onClick={() =>
                      setCurrentPage((prev) =>
                        currentPage < totalPages ? prev + 1 : prev
                      )
                    }
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Sales;
